import { configure } from 'mobx'
import LoginStore from './module/LoginStore'
import InstitutionStore from './module/AccountManage/InstitutionStore'
import AccountStore from './module/AccountManage/AccountStore'
import LogManageStore from './module/InfoStat/LogManageStore'
import ReportManageStore from './module/InfoStat/ReportManageStore'
import DashboardManageStore from './module/InfoStat/DashboardManageStore'
import ContentStore from './module/ContentStore'
import DeviceStatStore from './module/InfoStat/DeviceStatStore'
import ForgotUpwStore from './module/ForgotUpwStore'
import SystemInfoStore from './module/SystemInfoStore'

configure({
  enforceActions: 'always' // 严格模式
})

const stores = {
  LoginStore,
  InstitutionStore,
  AccountStore,
  LogManageStore,
  ContentStore,
  ReportManageStore,
  DashboardManageStore,
  DeviceStatStore,
  ForgotUpwStore,
  SystemInfoStore
}

export default stores
